import Vue from 'vue';
import Vuex from 'vuex';
import fetchJsonp from 'fetch-jsonp'

// const SOLR_PATH = 'http://solr-master-test.sbb.spk-berlin.de:8995/solr/ext-IKGF'
const SOLR_PATH = 'https://crossasia.org/solr/ext-IKGF'
const CATEGORIES = 'categories_ss'
const AUTHORS = 'author-editor-or-organization_ss'

Vue.use(Vuex);
const normalize = function(str) {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/[.,/#!$%^&*;:{}=\-_`~()ʻ"“]/gm,"").toUpperCase()
}

const getFq = (state, notIncluded=[]) => {
  let fqs = Object.entries(state.fq).filter(x => x[1].length > 0).filter(x => notIncluded.indexOf(x[0]) === -1)
  if (fqs.length > 0) {
    return 'fq=(' + fqs.map(entry => `${entry[0]}%3A(${entry[1].map(x => x.replace(/\s/gm,'*')).join(' ')})`).join(' AND ') +')'
  } else {
    return ''
  }
  
}

export default new Vuex.Store({
  state: {
    noOfPublications: 0,
    fq: {},
    q:"q=*%3A*&",
    start: 0,
    rows: 20,
    topics: [],
    authors: [],
    authorIndex: {},
    publications: []
  },
  mutations: {
    setKeyword(state,arg) {
      state.q = `q=${encodeURI(arg)}`
    },
    setStart(state,arg) {
      state.start = arg * state.rows
    },
    selectedTopics (state, arg) {
      console.log(arg)
      Vue.set(state.fq, 'categories_ss', arg)
    },
    selectedAuthors (state, arg) {
      // console.log(arg)
      Vue.set(state.fq, AUTHORS, arg)
    },
    async fetchTopics (state) {
      let response = await fetchJsonp(`${SOLR_PATH}/select?facet.limit=-1&facet.field=${CATEGORIES}&facet=on&q=*%3A*&rows=0&&wt=json`, {
        jsonpCallback: 'json.wrf',
      })
      let data = await response.json()
      let categories_ss = data.facet_counts.facet_fields.categories_ss.reduce((acc, obj, index, array) => {
        if (index > 0 && index % 2 == 1) {
          acc[array[index - 1]] = array[index]
        }
        return acc
      }, {})
      console.log('categories_ss', categories_ss)
      let topics = Object.keys(categories_ss).filter(x => x.length > 0)
      state.topics = topics.sort((a,b) => {
        let aNums = a.split(" ")[0].split('.')
        let bNums = b.split(" ")[0].split('.')
        
        for (let i = 0; i < 4; i++ ) {
          let aX = parseInt(aNums[i]) || 0
          let bX = parseInt(bNums[i]) || 0
          if (aX !== bX) {
            return aX > bX ? 1 : -1
          }
        }
      })

      // let termObj =  state.terms[arg.term]
      // state.terms[arg.term]["selectedNgrams"].push(arg.ngram)
      // Vue.set(state.terms, arg.term, termObj)
     },
     async fetchAuthors (state) {
      let response = await fetchJsonp(`${SOLR_PATH}/select?facet.limit=-1&facet.mincount=1&facet.field=${AUTHORS}&facet=on&${state.q}&${getFq(state,[AUTHORS])}&rows=0&wt=json`, {
        jsonpCallback: 'json.wrf',
      })
      let data = await response.json()
      let authors_ss = data.facet_counts.facet_fields[AUTHORS].reduce((acc, obj, index, array) => {
        if (index > 0 && index % 2 == 1) {
          acc[array[index - 1]] = array[index]
        }
        return acc
      }, {})
      // console.log('categories_ss', categories_ss)
      state.authors = Object.keys(authors_ss)
      state.authorIndex = state.authors.reduce((acc,author) => {
        let firstChar = normalize(author).charAt(0)
        // while (firstChar && !/[a-zA-Z]/.test(firstChar)) {
        //   firstChar = normalize(author).charAt(0)
        // }
        // console.log(firstChar, )
        let authorArray = acc[firstChar] || []
        authorArray.push(author)
        acc[firstChar] = authorArray
        return acc
      }, {})
     },
     async fetchPublications (state,) {
      // console.log(getFq(state))
       
      let response = await fetchJsonp(`${SOLR_PATH}/select?${state.q}&${getFq(state)}&start=${state.start}&rows=${state.rows}&wt=json&sort=author_index_s asc`, {
        jsonpCallback: 'json.wrf',
      })
      let data = await response.json()
      // console.log(data)
      state.noOfPublications = data.response.numFound
      state.publications = data.response.docs

      console.log(state.publications)
      // .sort((x, y) => {
      //   return ('' + x["author-editor-or-organization_ss"].join(";")).localeCompare('' + y["author-editor-or-organization_ss"].join(";"));
      // })
      // console.log(data.response.docs, state.publications)
     },
  }, 
  actions: {
    fetchTopics ({commit}, arg) {
      commit('fetchTopics', arg)
    },
    fetchAuthors ({commit}, arg) {
      commit('fetchAuthors', arg)
    },
    fetchPublications ({commit}, arg) {
      commit('fetchPublications', arg)
    },
    selectedTopics ({commit}, arg) {
      commit('selectedTopics', arg)
    },
    selectedAuthors ({commit}, arg) {
      commit('selectedAuthors', arg)
    },
    setPage ({commit}, arg) {
      commit('setStart', arg)
    },
    setKeyword ({commit}, arg) {
      commit('setKeyword', arg)
    },
  },
  getters: {
    getTopics: state => {
      return state.topics
    },
    getAuthors: state => {
      return state.authors
    },
    getAuthorsIndex: state => {
      return state.authorIndex
    },
    getSelectedAuthors: state => {
      return state.fq[AUTHORS] || []
    },
    getSelectedTopics: state => {
      return state.fq['categories_ss'] || []
    },
    getSelectedFieldCount: state => (field) =>{
      return state.fq[field] ? (state.fq[field].length > 0 ? `(${state.fq[field].length})` : '') : ''
    },
    getNoOfPublications: state => {
      return state.noOfPublications
    }
    
    // getTopics: (state, getters) => {
    //   return getters.doneTodos.length
    // }
  }
});
